/* src/app/views/admin/user-wallet/user-wallet.component.css */
:host ::ng-deep .p-tabview-nav li.p-highlight {
  color: #006ED3;
  border-bottom: 5px solid #006ED3;
}
::ng-deep p-paginator svg {
  transform: rotate(180deg);
}
/*# sourceMappingURL=user-wallet.component.css.map */
